import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AdminContext"
import PropTypes from 'prop-types';

export const ProtectedRoute = ({ children }) => {
    const { isLoged } = useAuth();

    if (isLoged) return children;
    return <Navigate to="/" />
}

ProtectedRoute.propTypes = {
    children: PropTypes.element.isRequired,
}